export default __webpack_public_path__ + "static/estrutura-5-e257ca1c245cdf16dfc49cfc56af55eb.png";